import { useState, useEffect } from "react";
import { Outlet, Link, router, useParams, useNavigate } from "react-router-dom";
import Chat from "../../compoenents/Chat";
import Cookies from "js-cookie";
import LoginCheck from "../../LoginCheck/page";
import { GetDate_, AppValues, API, ApiUrl } from "../../Values";
export default function DellerArbah(order) {
  const params = useParams();
  const [Data, SetData] = useState([]);
  const [delevary_price, Setdelevary_price] = useState(0);
  const [Inputs, SetInputs] = useState([
    {
      dateFrom: "",
      dateTo: "",
    },
  ]);
  //---------CHECK LOGIN------------------------------
  LoginCheck();
  var userinfo = [];
  var Username = "";
  var UserID = "";
  if (Cookies.get("userinfo")) {
    userinfo = JSON.parse(Cookies.get("userinfo"));
    Username = userinfo[0].Name;
    UserID = userinfo[0].ID;
  }
  //-------------------------------------------------
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    SetInputs((values) => ({ ...values, [name]: value }));
  };

  useEffect(() => {
    SetInputs((values) => ({ ...values, ["dateFrom"]: GetDate_.FirstMonth }));
    SetInputs((values) => ({ ...values, ["dateTo"]: GetDate_.Today }));
    GetData();
  }, []);
  //------------------------------------
  async function GetData() {
    try {
      const post = {
        Name: Username,
        ID: UserID,
        dateFrom: Inputs.dateFrom,
        dateTo: Inputs.dateTo,
        Action: "OrdersSearchArbah",
      };
      // console.log(post);
      const respons = await fetch(`${ApiUrl}/orders/orders.php`, {
        method: "POST",
        body: JSON.stringify(post),
      });
      const body = await respons.json();
      SetData(body.data);
      Setdelevary_price(body.delevary_price);
    } catch (error) {
      return error;
    }
  }

  return (
    <>
      <LoginCheck />
      <div
        dir="rtl"
        className="row mt-0 text-center0 m-auto "
        style={{ maxWidth: "500px" }}
      >
        <div className="col-1 py-1 bg-info ">
          <Link to="../Deller/Account">
            <i className="fa-solid fa-chevron-right  text-white mt-2 fs-4"></i>
          </Link>
        </div>
        <div className="col-11 py-1 text-center bg-info text-white">
          <h4>{"  حساب الارباح "}</h4>
        </div>
        <br />

        <div  className="col-5 mt-0 px-1">
          <label className="col-form-label">من تاريخ</label>
          <input
         
            type="date"
            name="dateFrom"
            onChange={handleChange}
            value={Inputs.dateFrom}
            className="form-control"
          />
        </div>
        <div className="col-5 mt-0 px-1">
          <label className="col-form-label">الى تاريخ</label>
          <input
       
            type="date"
            name="dateTo"
            onChange={handleChange}
            value={Inputs.dateTo}
            className="form-control"
          />
        </div>

        <div className="col-2 text-center mt-0 px-1">
        <label className="col-form-label text-light"> gh</label>
          <button
            onClick={GetData}
            className="btn btn-orange fw-bold p-1 w-100 mt-1"
          >
            احسب
          </button>
        </div>

        <div className="col-12 text-center mt-3">
          <h3>الارباح :  {` ${delevary_price} جنية`}</h3>
        </div>
        <div className="col-master col-card-alert col-12 mb-4 pt-1">
          {Data.length > 0 && <CardItem />}
          {Data.length < 1 ? <NoORDER /> : null}
          <br /><br /><br />
          <br /><br />   <br /><br />
        </div>
      </div>
    </>
  );

  function CardItem() {
    return Data.map((x, index) => {
      let classStatu = "";

      if (x.statue == "جارى التاكيد") {
        classStatu = "btn-primary";
      }
      if (x.statue == "ملغى") {
        classStatu = "btn-danger";
      }
      if (x.statue == "جارى التنفيذ") {
        classStatu = "btn-orange";
      }
      if (x.statue == "جارى التوصيل") {
        classStatu = "btn-syan";
      }
      if (x.statue == "تم التوصيل") {
        classStatu = "btn-green";
      }

      return (

        <div key={index} className=" card-content card" style={{ maxWidth: "500px" }}>
          <div className="card-body p-0">
            <div className="row">
              <div className="col-1 text-center p-1">

                <img
                  style={{
                    height: "38px",
                    width: "38px",
                    borderRadius: "19px",
                  }}
                  src={x.logo}
                  alt=""
                  loading="lazy"
                  onError={(e) => {
                    e.target.src = "../../../Images/gps.png";
                  }}
                />
              </div>
              <div className="col-10">
                <span
                  style={{ fontSize: "1.1em", color: "#000", fontWeight: "bold" }}
                >
                  {x.type_order}
                </span>
                <small className="float-start">{"#" + x.number_order} </small>
              </div>

              <div className="col-4">
                <h6
                  style={{
                    fontSize: "11px",
                    fontWeight: "bold",
                    color: "#00C1BC",
                  }}
                >
                  {x.date_delivery}
                </h6>
              </div>
              <div className="col-4">
                <h6
                  style={{
                    fontSize: "13px",
                    fontWeight: "bold",
                    color: "#EF6242",
                  }}
                >
                  {x.delevary_price} جنية
                </h6>
              </div>
              <div className="col-12 mb-1 p-0 px-2">
                <i className="fa-solid fa-location-dot text-green pt-1 ms-1"> من : </i>
                <small
                  className="p-0 m-0 pe-0"
                  style={{
                    fontSize: "12px",
                    color: "#000",
                    fontWeight: "bold",
                  }}
                >
                  {x.from_plase}
                </small>
                <br />
                <i className="fa-solid fa-location-dot text-green pt-1 ms-1"> الى : </i>
                <small
                  className="p-0 m-0 pe-0"
                  style={{
                    fontSize: "12px",
                    color: "#000",
                    fontWeight: "bold",
                  }}
                >
                  {x.to_plase}
                </small>
              </div>
              {/* <div className="col-8 text-center">
                <Link to={`../Deller/OrderInfo/${x.number_order}`}>
                  <button
                    style={{ width: "100px" }}
                    className={"btn btn-sm p-0 fw-bold " + classStatu}
                  >
                    {x.statue}
                  </button>
                </Link>
              </div> */}
            </div>
          </div>
        </div>

      );
    });
  }
}
function NoORDER() {
  return (
    <div className="card">
      <div className="card-body text-center " style={{ height: "650px" }}>
        <br /> <br /> <br />
        <div className="StartpageDiv0">
          <img
            style={{ width: "150px" }}
            src="../../../Images/no_order2.png"
            alt="no_alert"
          />
        </div>
        <br /> <br /> <br />
        <h4>لا يوجد هناك طلبات توصيل لديك</h4>
        <br /> <br /> <br />
      </div>
    </div>
  );


}
